import { Component } from "react";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { isInterventionTerminated } from "../../../redux/intervention/extranetInterventionStatus";
import { Card } from "@mui/material";
import TableWithPagination from "../../Table/TableWithPagination";
import { connect } from "react-redux";
import {
    loadIntervention,
    setFilteredAndSortedInterventions,
} from "../../../redux/intervention/extranetInterventionActions";
import { withRouter } from "react-router";
import { compose } from "redux";
import { MODULE_EXTRANET_INTERVENTIONS } from "../../../redux/authorizedApps/authorizedAppsConstants";

class InterventionsAsTable extends Component {
    fetchData(state) {
        let tableState = {
            pageSize: state.pageSize,
            pageNumber: state.page,
            orderBy: state.sorted.length > 0 ? state.sorted[0].id : "",
            descOrder: state.sorted.length > 0 ? state.sorted[0].desc : false,
        };

        this.props.setFilteredAndSortedInterventions(
            this.props.interventionsFilters,
            this.props.componentPark,
            this.props.affair,
            tableState,
            this.props.activeUser,
            this.props.sites.selectedSite,
            this.props.sites.sites,
            this.props.tableState.nbTotalResults
        );
    }

    loadIntervention(intervention) {
        if (!isInterventionTerminated(intervention.state)) return;

        this.props.loadIntervention(intervention, this.props.activeUser);
        this.props.history.push("/interventions/intervention");
        this.props.globalStore.container.current.scrollTop = 0;
    }

    getTableTrProps(row) {
        if (row) {
            return {
                onClick: this.loadIntervention.bind(this, row.row.original),
                style: {
                    cursor: "pointer",
                },
            };
        } else {
            return {};
        }
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <Card>
                <TableWithPagination
                    ref={this.table}
                    data={this.props.plannedInterventions.filter(
                        (a) => !a.deleted
                    )}
                    pages={Math.ceil(
                        this.props.tableState.nbTotalResults[
                            MODULE_EXTRANET_INTERVENTIONS
                        ] / this.props.tableState.pageSize
                    )}
                    manual
                    columns={this.props.columns}
                    onFetchData={this.fetchData.bind(this)}
                    getTrProps={this.getTableTrProps.bind(this)}
                />
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        tableState: state.tableState,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadIntervention: (intervention, user) =>
            dispatch(loadIntervention(intervention, user)),
        setFilteredAndSortedInterventions: (
            interventionsFilters,
            componentPark,
            affair,
            tableState,
            user,
            customerSiteId,
            allSites,
            nbTotalResults
        ) =>
            dispatch(
                setFilteredAndSortedInterventions(
                    interventionsFilters,
                    componentPark,
                    affair,
                    tableState,
                    user,
                    customerSiteId,
                    allSites,
                    nbTotalResults
                )
            ),
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(InterventionsAsTable);
